import * as React from 'react';
import { TabStyles } from '../styles/TabStyles';
import { InteractiveDomHoCDecorator, InteractiveStyles } from '../utils/InteractiveDom';

/** @deprecated this is not a very useful Widget. Please contact #tab-dev-shared-widgets if you have a use case. */
export interface InputLabelProps {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  id?: string;
  style?: React.CSSProperties;

  /** The testId of the label, will be appended with '-Label' */
  testId: string;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  interactiveStyles?: InteractiveStyles;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  handleHover?: (hover: boolean) => void;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  handleActive?: (active: boolean) => void;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  handleFocus?: (focus: boolean) => void;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerClick?: (event: React.SyntheticEvent) => void;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerDown?: (event: React.SyntheticEvent) => void;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerDoubleClick?: (event: React.SyntheticEvent) => void;
  /** @deprecated post in #tab-dev-shared-widgets, or if urgently necessary, use an InteractiveDomWrapper */
  pointerUp?: (event: React.SyntheticEvent) => void;
}

const { Typography } = TabStyles;

const getStyle = (disabled?: boolean): React.CSSProperties => ({
  fontSize: Typography.Sizing.Default,
  fontWeight: 'normal',
  color: disabled ? Typography.Color.Disabled : Typography.Color.Primary,
  lineHeight: 'normal',
  cursor: 'default'
});

const labelMouseDownHandler = (e: React.MouseEvent) => {
  if (!(e.target instanceof HTMLInputElement)) {
    e.preventDefault();
  }
};

/** @deprecated this is not a very useful Widget. Please contact #tab-dev-shared-widgets if you have a use case. */
@InteractiveDomHoCDecorator
// eslint-disable-next-line deprecation/deprecation
export class InputLabelWidget extends React.Component<InputLabelProps, {}> {
  public render(): JSX.Element {
    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <label
        className={this.props.className}
        data-tb-test-id={this.props.testId + '-Label'}
        id={this.props.id}
        style={{ ...getStyle(this.props.disabled), ...this.props.style }}
        onMouseDown={labelMouseDownHandler}
      >
        {this.props.children}
      </label>
    );
  }
}
